import React from 'react';
import { HashRouter as Router, Routes, Route } from 'react-router-dom';
import { motion } from 'framer-motion';
import Navigation from './components/Navigation';
import Dashboard from './components/Dashboard';
import ExecutiveSummary from './components/ExecutiveSummary';
import RoleBreakdown from './components/RoleBreakdown';
import SystemArchitecture from './components/SystemArchitecture';
import CoreModules from './components/CoreModules';
import SOPLibrary from './components/SOPLibrary';
import DashboardTemplate from './components/DashboardTemplate';
import ReportingSuite from './components/ReportingSuite';
import Implementation from './components/Implementation';
import Expansion from './components/Expansion';
import './App.css';

function App() {
  return (
    <Router>
      {/* Updated Background Class */}
      <div className="min-h-screen app-container text-charcoal font-sans selection:bg-sage-100 selection:text-charcoal">
        <Navigation />
        
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="pt-24 pb-12"
        >
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/executive-summary" element={<ExecutiveSummary />} />
            <Route path="/role-breakdown" element={<RoleBreakdown />} />
            <Route path="/architecture" element={<SystemArchitecture />} />
            <Route path="/modules" element={<CoreModules />} />
            <Route path="/sop-library" element={<SOPLibrary />} />
            <Route path="/dashboard-template" element={<DashboardTemplate />} />
            <Route path="/reporting" element={<ReportingSuite />} />
            <Route path="/implementation" element={<Implementation />} />
            <Route path="/expansion" element={<Expansion />} />
          </Routes>
        </motion.div>
      </div>
    </Router>
  );
}

export default App;